import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaPencilAlt } from "react-icons/fa";
import Header from "../../header";
import Navvbar from "../../Navvbar";
import Sidebar from "../../../Sidebar";
import axios from "axios";
import Swal from "sweetalert2";
import "./addNewUser.css";

const AddNewUser = () => {
  const [formData, setFormData] = useState({
    salutation: "Mr",
    first_name: "",
    middleInitial: "",
    last_name: "",
    externalId: "",
    username: "",
    email: "",
    password: "",
    role: "Dental Lab",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [adminLabId, setAdminLabId] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    const userLabId = localStorage.getItem("userLabId");

    if (userRole !== "Admin") {
      Swal.fire({
        title: "Access Denied",
        text: "Only Admin users can add new users",
        icon: "warning",
        confirmButtonColor: "#004aad",
      }).then(() => {
        navigate("/home");
      });
      return;
    }

    setAdminLabId(userLabId || "");
  }, [navigate]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const token = localStorage.getItem("accessToken");

      if (!token) {
        Swal.fire({
          title: "Error!",
          text: "You need to be logged in to add users",
          icon: "error",
          confirmButtonColor: "#004aad",
        });
        setIsSubmitting(false);
        return;
      }

      await axios.post(
        "https://hms.backend.hiragroupcloud.com/api/auth/add",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire({
        title: "Success!",
        text: "User added successfully!",
        icon: "success",
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,
      });

      setFormData({
        salutation: "Mr",
        first_name: "",
        middleInitial: "",
        last_name: "",
        externalId: "",
        username: "",
        email: "",
        password: "",
        role: "Dental Lab",
      });

      setTimeout(() => {
        navigate("/users");
      }, 2000);
    } catch (err) {
      let errorMessage = "An unexpected error occurred.";

      if (err.response) {
        if (err.response.status === 401) {
          errorMessage = "Session expired. Please login again.";
          localStorage.clear();
          Swal.fire({
            title: "Session Expired",
            text: errorMessage,
            icon: "error",
            confirmButtonColor: "#004aad",
          }).then(() => {
            navigate("/login");
          });
        } else if (err.response.status === 403) {
          errorMessage =
            "Permission denied. Only Admin users can add new users.";
        } else {
          errorMessage =
            err.response.data?.message || "Failed to add user.";
        }
      } else if (err.request) {
        errorMessage = "Network error. Please check your connection.";
      }

      Swal.fire({
        title: "Error!",
        text: errorMessage,
        icon: "error",
        confirmButtonColor: "#004aad",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header />
      <Navvbar />

      <br />

      <div className="add-user-wrapper">
        <div className="add-user-row">

          {/* ================= SIDEBAR ================= */}
          <div className="add-user-sidebar">
            <Sidebar />
          </div>

          {/* ================= MAIN CONTENT ================= */}
          <div className="add-user-main">
            <div className="main-content">

              <h2>Add New User</h2>

              <h3 className="user-details-title">
                User Details
              </h3>

              <div className="user-form-box">
                <form onSubmit={handleSubmit}>

                  <div className="form-field-row">
                    <label htmlFor="salutation">Salutation</label>
                    <select
                      id="salutation"
                      className="form-control user-form-control"
                      value={formData.salutation}
                      onChange={handleChange}
                      disabled={isSubmitting}
                    >
                      <option value="Mr">Mr</option>
                      <option value="Mrs">Mrs</option>
                      <option value="Ms">Ms</option>
                      <option value="Dr">Dr</option>
                      <option value="Prof">Prof</option>
                    </select>
                  </div>

                  <br />

                  <div className="form-field-row">
                    <label htmlFor="first_name">First Name *</label>
                    <input
                      type="text"
                      id="first_name"
                      className="form-control user-form-control"
                      value={formData.first_name}
                      onChange={handleChange}
                      required
                      disabled={isSubmitting}
                    />
                  </div>

                  <br />

                  <div className="form-field-row">
                    <label htmlFor="middleInitial">Middle Initial</label>
                    <input
                      type="text"
                      id="middleInitial"
                      className="form-control user-form-control"
                      value={formData.middleInitial}
                      onChange={handleChange}
                      maxLength="1"
                      disabled={isSubmitting}
                    />
                  </div>

                  <br />

                  <div className="form-field-row">
                    <label htmlFor="last_name">Last Name *</label>
                    <input
                      type="text"
                      id="last_name"
                      className="form-control user-form-control"
                      value={formData.last_name}
                      onChange={handleChange}
                      required
                      disabled={isSubmitting}
                    />
                  </div>

                  <br />

                  <div className="form-field-row">
                    <label htmlFor="externalId">External ID</label>
                    <input
                      type="text"
                      id="externalId"
                      className="form-control user-form-control"
                      value={formData.externalId}
                      onChange={handleChange}
                      disabled={isSubmitting}
                    />
                  </div>

                  <br />

                  <div className="form-field-row">
                    <label htmlFor="username">Username *</label>
                    <input
                      type="text"
                      id="username"
                      className="form-control user-form-control"
                      value={formData.username}
                      onChange={handleChange}
                      required
                      disabled={isSubmitting}
                    />
                  </div>

                  <br />

                  <div className="form-field-row">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      className="form-control user-form-control"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      disabled={isSubmitting}
                    />
                  </div>

                  <br />

                  <div className="form-field-row">
                    <label htmlFor="password">Password *</label>
                    <input
                      type="password"
                      id="password"
                      className="form-control user-form-control"
                      value={formData.password}
                      onChange={handleChange}
                      required
                      minLength="6"
                      disabled={isSubmitting}
                    />
                  </div>

                  <br />

                  <div className="submit-section">
                    <button
                      type="submit"
                      className="add-user-submit-button"
                      disabled={isSubmitting}
                    >
                      <FaPencilAlt />
                      {isSubmitting ? "Adding..." : "Add User"}
                    </button>

                    {isSubmitting && (
                      <span className="adding-message">
                        Adding user with role "Dental Lab"...
                      </span>
                    )}
                  </div>

                </form>
              </div>

              <br />

            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default AddNewUser;